var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIconRestyling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 59 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#lockIconRestyling_svg__a)",
  fillRule: "evenodd",
  d: "M19.175 21.388H14.75V14.75A8.85 8.85 0 0 1 23.6 5.9h12.538a8.85 8.85 0 0 1 8.85 8.85v6.638h-4.425v-5.9a5.16 5.16 0 0 0-5.163-5.163H24.338a5.16 5.16 0 0 0-5.163 5.163z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#lockIconRestyling_svg__b)",
  d: "M10.325 46.15a4 4 0 0 0 4 4h31.088a4 4 0 0 0 4-4V25.388a4 4 0 0 0-4-4H14.325a4 4 0 0 0-4 4z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "lockIconRestyling_svg__a",
  x1: 14.75,
  x2: 44.987,
  y1: 21.388,
  y2: 21.388,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DA1781"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF008B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "lockIconRestyling_svg__b",
  x1: 10.325,
  x2: 49.413,
  y1: 50.15,
  y2: 50.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DA1781"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF008B"
})))));
export default SvgLockIconRestyling;